import React from 'react';
import { Box, BoxProps } from 'pounce';
import { useTabsContext } from './Tabs';

export type TabPanelsProps = BoxProps & {
  style?: React.CSSProperties;
  children: React.ReactNode;
};

type TabPanelCloneProps = {
  index: number;
  value: number | undefined;
  tabIndex: number;
};

const TabPanels = React.forwardRef<HTMLDivElement, TabPanelsProps>(function TabPanels(
  { children, ...rest },
  ref,
) {
  const { selectedIndex } = useTabsContext();

  return (
    <Box ref={ref} {...rest}>
      {React.Children.toArray(children).map((child, index) =>
        React.cloneElement(child as React.ReactElement<TabPanelCloneProps>, {
          index,
          key: `tabpanel-${index}`,
          value: selectedIndex,
          tabIndex: index,
        }),
      )}
    </Box>
  );
});

export default TabPanels;
